import React from 'react';
import styled, { DefaultTheme } from 'styled-components';

const DividerStyled = styled.div<{ theme: DefaultTheme }>`
  align-self: stretch;

  @media ${({ theme }) => theme.mq.min.tablet} {
    height: 1px;
  }

  @media ${({ theme }) => theme.mq.max.tablet} {
    width: 1px;
    margin: 0 2px;
  }

  div {
    @media ${({ theme }) => theme.mq.min.tablet} {
      border-bottom: 1px solid #30577c;
      margin: 0 4px;
    }

    @media ${({ theme }) => theme.mq.max.tablet} {
      height: 100%;
      border-left: 1px solid #30577c;
    }
  }
`;

const Divider = () => (
  <DividerStyled className="divider">
    <div></div>
  </DividerStyled>
);

export default Divider;
